module.exports = __webpack_public_path__ + "src/assets/img/bg16.02798526.jpg";